export default {
  headerButton: {
    fontSize: '20px',
  },
  partnershipButton: {
    fontSize: '16px',
  },
}
